const routes = {
    MAIN: '/admin',
    LOGIN: '/admin/login',
    VERIFY: '/admin/verify',
    ARCHIVES: '/admin/archives',
    REVIEWS: '/admin/reviews',
    USERS: '/admin/users',
    OTHER: '*'
};

export default routes ;
